module.exports = __WEBPACK_EXTERNAL_MODULE_83__;


/*****************
 ** WEBPACK FOOTER
 ** external "d3"
 ** module id = 83
 ** module chunks = 0
 **/